import { GetLargeUrl, GetMediumUrl } from "~/utils/images";
import { ProductTile } from "../../../types/ProductTile";
import { NavLink } from "@remix-run/react";
import { formatPrice } from "~/utils/strings";

export const SmallProduct = ({
    url,
    brand,
    title,
    slug,
    price,
    soldOut,
    hasVariations,
    discount,
    isMobile,
}: ProductTile & {
    url: string;
    viewTransition?: boolean;
    hasVariations: boolean;
    discount: number;
    isMobile: boolean;
}) => {
    const prefetchLarge = () => {
        const img = new Image();
        img.src = GetLargeUrl(url);
    };
    const prefetchImage = () => {
        const img = new Image();
        img.src = GetMediumUrl(url);
    };

    return (
        <NavLink
            prefetch={isMobile ? "viewport" : "intent"}
            className="text-center"
            to={`/product/${slug}`}
            unstable_viewTransition={true}
            onMouseEnter={prefetchImage}
            onFocus={prefetchImage}
        >
            {({ isTransitioning }) => (
                <div>
                    <div className="relative flex flex-row items-center justify-center">
                        {soldOut ? (
                            <HeaderLabel className="bg-[#E3DACC]">
                                Uppselt
                            </HeaderLabel>

                        ) : hasVariations ? (
                            <HeaderLabel className="bg-[#EFD4D7]">
                                Fleiri valmöguleikar
                            </HeaderLabel>

                        ) : null}
                        <img
                            loading="lazy"
                            height={275}
                            width={275}
                            className="rounded-[6px] text-center"
                            src={GetMediumUrl(url)}
                            onFocus={prefetchLarge}
                            onMouseEnter={prefetchLarge}
                            alt={title}
                            style={{
                                viewTransitionName: isTransitioning
                                    ? "product-image"
                                    : undefined,
                            }}
                        />
                    </div>
                    <div className="mt-8 flex flex-col items-center">
                        <div className="text-base text-[#A3865A] ">{brand}</div>
                        <div className="text-base font-normal text-[#0E0F0F]">{title}</div>
                        <div className="flex flex-row gap-x-2">
                            <div
                                className={`text-sm font-semibold text-[#0E0F0F] opacity-50 ${discount ? "line-through" : ""}`}
                            >
                                {formatPrice(price)}
                            </div>
                            {discount > 0 && (
                                <div className="text-sm font-semibold text-[#FF3636]">
                                    {formatPrice(price * (1 - discount))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </NavLink>
    );
};


const HeaderLabel = ({
    children, className
}: {
    children: React.ReactNode;
    className?: string;
}) => {

    return < div className={`absolute left-0 top-0 px-2 py-2 font-semibold text-sm sm:text-base w-full sm:w-auto rounded-t-[6px] sm:rounded-none ${className}`} >
        {children}
    </div >
}